import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Department, SiteCodes } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-department-dialog',
  templateUrl: './add-department-dialog.component.html',
  styleUrls: ['./add-department-dialog.component.css']
})
export class AddDepartmentDialogComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<AddDepartmentDialogComponent>,
    private _safetyConfigService:SafetyConfigService,

  ) { }

  selectedName:string = ""
  selectedDescription:string = ""
  siteCodesList: SiteCodes[]=[];
  inputValuestate:number
  inputValueSefetyObservation:number
  ngOnInit() {
    this. loadSiteList()
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
  state = new FormControl("", [Validators.required]);
  sefetyobservation = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  getObservationErrorMessage() {
    return this.sefetyobservation.hasError("required") ? "You must enter a value" : "";
  }
  loadSiteList()
  {
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      console.log('sitelist',sites)
      this.siteCodesList=sites;
      
    });
  }
  addDepartment()
  {
    if(this.inputValueSefetyObservation == undefined || this.selectedName==undefined || this.inputValueSefetyObservation <=0 || this.selectedName=="" || this.inputValuestate ==undefined){
      return;  
      }else{
        let model= new Department()
        model.DepartmentName=this.selectedName;
        model.DepartmentDescription=this.selectedDescription
        model.SiteId=this.inputValuestate
        model.ObservationTypeId=this.inputValueSefetyObservation
        console.log('input values',model)
    this._safetyConfigService.CreateDepartment(model).subscribe(res =>{
     
      if(res.m_Item1=true){
        console.log('result', res)
        this.DialogClose();
       
      }
      
    });
      }
    
  }

}
